import React from "react";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";

import DepotSquareAssociatedLocation from "../DepotSquareAssociatedLocation";

const DepotSquareAssociatedLocations = ({ t, column, value, onPropChange }) => {
    const handleOnSelect = index => {
        onPropChange({ 
            [column.accessor]: (value || [])
                .map((val, i)=> i === index ? { ...val, active: true } : { ...val, active: false }) 
        });
    }

    return (
        <div className={classNames("depotSquareAssociatedLocations")}>
            <div className={classNames("titleItems")}>
                <img alt="Delivr+" src="/assets/defaulticons/logo_UK.svg" />
                <div className={classNames("textInfo")}>+</div>
                <img alt="Delivr+" src="/assets/defaulticons/square-icon.png" />
            </div>
            <div className={classNames("items")}>
                {(value || []).map((squareAssociatedLocation, index)=> (
                    <DepotSquareAssociatedLocation 
                        key={squareAssociatedLocation.id} 
                        index={index} 
                        value={squareAssociatedLocation} 
                        onSelect={handleOnSelect} 
                    />
                ))}
            </div>            
        </div>
    );
}

export default withTranslation()(DepotSquareAssociatedLocations);
 